var html = require("choo/html");
var { i18n } = require("../../components/base");
var Intro = require("../../components/intro");
var Countdown = require("../../components/countdown");
var { DEADLINE, OPEN } = require("../../lib/dates");

var text = i18n();

module.exports = home;

function home(state, emit) {
  emit("meta", {
    title: text`SITE_NAME`,
    description: text`SITE_DESCRIPTION`,
    "og:image": "https://www.designstipendiet.se/share-image.png",
    "og:url": "https://www.designstipendiet.se",
  });

  return html`
    <body>
      <main class="Home js-scroll">
          <div class="Home-sidebar">
              ${state.cache(Intro, "homepage-intro").render()}
          </div>
        <div class="Home-main">
          <div class="Home-content">
            <p>Din framtid kan bÃÂ¶rja pÃÂ¥ Beckmans KvÃÂ¤llsskola!</p>
            <p>
              Ett stipendium till fÃÂ¶r dig som vill gÃÂ¥ nÃÂ¥gon av de tre
              kvÃÂ¤llskurserna pÃÂ¥
              <span>
                <a href="https://beckmans.se/kvallsskolan/" target="_blank">Beckmans KvÃÂ¤llsskola </a>.
              </span>
              <span>
                <a href="https://weilfoundation.se/" target="_blank">Familjen Robert Weils stiftelse</a>
              </span>
              har grundat Designstipendiet fÃÂ¶r att alla, oavsett bakgrund, ska
              kunna ha mÃÂ¶jlighet att tacka ja om de erbjuds en plats.
            </p>
            <nav class="Home-nav">
              ${(DEADLINE > Date.now() && OPEN < Date.now())
                ? html`<a href="/ansok" class="Home-apply">SÃÂ¶k Stipendiet</a>`
                : (DEADLINE < Date.now() ? html`<span style="color: black">ÃÂrets ansÃÂ¶kning ÃÂ¤r nu stÃÂ¤ngd<br /><br /></span>` : html`<span style="color: black">AnsÃÂ¶kan ÃÂ¶ppnar i slutet av januari 2026<br /><br /></span>`)}
              <a href="/info" class="Home-menu">Mer info</a>
            </nav>
          </div>
          ${(DEADLINE > Date.now() && OPEN < Date.now())
            ? html`
                <div class="Home-footer">
                  ${state.cache(Countdown, "home-timer").render(DEADLINE)}
                </div>
              `
            : null}
        </div>
      </main>
    </body>
  `;
}
